import React, { useEffect, useState, useContext } from 'react';
import destinaterieM2Service from '@auteco/services/destinatariesM2Service';
import { useHistory } from 'react-router-dom';
import swal from 'sweetalert';
import { swalMessages } from '@auteco/constants';
import { Context } from '../../context/Contex';
import Metros2Page from '../../pages/MaestrosPage/Metros2Page/Metros2Page';

const filters = {
  CANAL: null,
  ESTADO: null,
};
const filterValues = ({ item, param, value }) => {
  const empty = !value || value === '';
  const valid = item[param] === value;
  return valid || empty;
};

const DestinatairesM2 = () => {
  const [channels, setChannels] = useState([]);
  const [filtersArr, setFiltersArr] = useState([]);
  const [destinataries, setAllDestinataries] = useState([]);
  const [filterKeys, setFilterKeys] = useState(filters);

  const history = useHistory();
  const { unidad } = useContext(Context);

  const onChangeFilter = (value, key) => {
    setFiltersArr([]);
    Object.assign(filterKeys, { [key]: value });
    const updatedValues = Object.keys(filterKeys).reduce(
      (reducedValues, filterKey) => {
        const reducedValue = reducedValues.filter((item) => filterValues({
          item,
          param: filterKey,
          value: filterKeys[filterKey],
        }));
        return reducedValue;
      },
      destinataries,
    );
    setFiltersArr(updatedValues);
  };

  const fetchM2 = async (unityId) => {
    const { success, data } = await destinaterieM2Service.getM2(unityId);
    if (success && data.length > 0) {
      setAllDestinataries(data);
      setFiltersArr(data);
      setFilterKeys({ ESTADO: null, CANAL: null });
    } else {
      swal(swalMessages.GENERAL_ERROR);
    }
  };
  const fetchChannels = async (unityId) => {
    const { success, data } = await destinaterieM2Service.getChannels(unityId);
    if (success) {
      setChannels(data);
    } else {
      swal(swalMessages.GENERAL_ERROR);
    }
  };

  const handleUpdatem2 = async ({ newData }) => {
    const { success } = await destinaterieM2Service.putM2({
      unidad,
      tipo: 'actualizar',
      m2: newData.metros2 || '',
      canal: newData.CANAL || '',
      destinatario: newData.Cliente_Destinatario || '',
    });

    if (success) {
      const updateRow = destinataries.map((row) => {
        if (row.Cliente_Destinatario === newData.Cliente_Destinatario) {
          return {
            ...row,
            ...newData,
          };
        }
        return row;
      });
      setAllDestinataries(updateRow);
    } else {
      swal(swalMessages.GENERAL_ERROR);
    }
  };

  const redirectToHome = (unityId) => {
    if (unityId === '2' || unityId === '6') {
      fetchM2(unityId);
      fetchChannels(unityId);
    } else {
      swal(swalMessages.NOT_AVAILABLE).then(() => {
        history.push('/home');
      });
    }
  };

  const handleChange = async (event, rowData) => {
    const checked = event.target.checked ? '1' : '0';
    const destinataire = rowData.Cliente_Destinatario;
    const { success } = await destinaterieM2Service.putM2({
      unidad,
      estado: checked,
      tipo: 'actualizar_estado',
      destinatario: destinataire,
    });
    if (success) {
      const updateRow = destinataries.map((row) => {
        if (row.Cliente_Destinatario === destinataire) {
          return {
            ...row,
            ESTADO: checked,
          };
        }
        return row;
      });
      setAllDestinataries(updateRow);
      swal(swalMessages.SUCCESFUL_UPDATE);
    } else {
      swal(swalMessages.GENERAL_ERROR);
    }
  };

  const lookup = channels.reduce((reduced, current) => {
    const reducedValue = { [current.canal]: current.canal };
    return Object.assign(reduced, reducedValue);
  }, {});

  useEffect(() => {
    redirectToHome(unidad);
  }, []);

  useEffect(() => {
    if (destinataries.length > 0) {
      onChangeFilter(filterKeys.CANAL, 'CANAL');
    }
  }, [destinataries]);

  return (
    <Metros2Page
      lookup={lookup}
      filters={filterKeys}
      channels={channels}
      destinataries={filtersArr}
      handleChange={handleChange}
      handleUpdatem2={handleUpdatem2}
      onChangeFilter={onChangeFilter}
    />
  );
};

export default DestinatairesM2;
